export const iconFontAwesomeMedicalHealthVialCircleCheck = (
	<i className="fa-solid fa-vial-circle-check"></i>
);
